import { render, staticRenderFns } from "./ShadowedWrapper.vue?vue&type=template&id=54eb5d7c&"
import script from "./ShadowedWrapper.vue?vue&type=script&lang=js&"
export * from "./ShadowedWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports